import { combineReducers } from 'redux';
import alertReducer from './AlertReducer';
import confirmReducer from './ConfirmReducer';
import customizationReducer from './CustomizationReducer';
import otpReducer from './OtpReducer';
import onboardingReducer from './OnboardingReducer';
import loadingReducer from './LoadingReducer';
import changePassReducer from './ChangePassReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const Reducer = combineReducers({
    customization: customizationReducer,
    alert: alertReducer,
    otp: otpReducer,
    confirm: confirmReducer,
    onboarding: onboardingReducer,
    loading: loadingReducer,
    first: changePassReducer,
});

export default Reducer;
